export const Solid = Object.freeze({
	THREE_PERSONS: 's-3-persons',
	ACTIVITY: 's-activity',
	AI_STARS: 's-ai-stars',
	ALERT_ACCENT: 's-alert-accent',
	ALERT: 's-alert',
	APPS: 's-apps',
	ATTACH: 's-attach',
	BOARD: 's-board',
	BOOKMARK: 's-bookmark',
	BOTTLENECK: 's-bottleneck',
	BROWSER: 's-browser',
	BUG: 's-bug',
	BUSINESS_PROCESS: 's-business-process',
	CALENDAR_WITH_SLOTS: 's-calendar-with-slots',
	CAMERA: 's-camera',
	CHATS: 's-chats',
	CHECK: 's-check',
	CIRCLE_CHECK: 's-circle-check',
	CLOCK: 's-clock',
	CLOUD_SYNC: 's-cloud-sync',
	CLOUD: 's-cloud',
	COLLAB: 's-collab',
	COLLABORATION: 's-collaboration',
	COMPANY: 's-company',
	COMPLETE_TASK_LIST: 's-complete-task-list',
	CONTACT_CENTER: 's-contact-center',
	COPILOT: 's-copilot',
	CRM_LETTERS: 's-crm-letters',
	CRM: 's-crm',
	CROWN: 's-crown',
	CURSOR_CLICK: 's-cursor-click',
	DATABASE: 's-database',
	DEPARTMENT: 's-department',
	DEVELOPER_RESOURCES: 's-developer-resources',
	DOCUMENT_SIGN: 's-document-sign',
	EARTH: 's-earth',
	EMPLOYEE: 's-employee',
	ENTERPRISE: 's-enterprise',
	FAVORITE: 's-favorite',
	FILE: 's-file',
	FIRE: 's-fire',
	FOLDER: 's-folder',
	FULL_BATTERY: 's-full-battery',
	GRADUATION_CAP: 's-graduation-cap',
	GRAPHS_DIAGRAM: 's-graphs-diagram',
	GROUP: 's-group',
	HANDSHAKE: 's-handshake',
	HEART: 's-heart',
	HOME: 's-home',
	KANBAN: 's-kanban',
	KEY: 's-key',
	KNOWLEDGE_BASE: 's-knowledge-base',
	LEAD: 's-lead',
	LIKE: 's-like',
	LOCATION: 's-location',
	MAGIC_WAND: 's-magic-wand',
	MAIL: 's-mail',
	MAIN_TOOL: 's-main-tool',
	MARKET: 's-market',
	MARKETING: 's-marketing',
	MESSAGE: 's-message',
	MICROPHONE_ON: 's-microphone-on',
	MOON: 's-moon',
	NEUTRAL: 's-neutral',
	NEWSFEED: 's-newsfeed',
	NOTE: 's-note',
	NOTIFICATION: 's-notification',
	OBSERVER: 's-observer',
	ONLINE_BOOKING: 's-online-booking',
	OPEN_CHANNELS: 's-open-channels',
	PAUSE: 's-pause',
	PAYMENT_TERMINAL: 's-payment-terminal',
	PERSON: 's-person',
	PHONE_ADD: 's-phone-add',
	PHONE_BROKEN: 's-phone-broken',
	PHONE_IN: 's-phone-in',
	PHONE_OUT: 's-phone-out',
	PHONE_UP: 's-phone-up',
	PIN: 's-pin',
	PLAY: 's-play',
	PLUS: 's-plus',
	PROCESSES: 's-processes',
	PRODUCT_WRAPPED: 's-product-wrapped',
	PRODUCT: 's-product',
	RECORD_VIDEO: 's-record-video',
	REFRESH: 's-refresh',
	REPEAT: 's-repeat',
	ROBOT: 's-robot',
	ROCKET: 's-rocket',
	ROLES_LIBRARY: 's-roles-library',
	SAD: 's-sad',
	SCREEN: 's-screen',
	SERVICE: 's-service',
	SETTINGS: 's-settings',
	SHIELD_CHECKED: 's-shield-checked',
	SHIELD: 's-shield',
	SHOPPING_CART: 's-shopping-cart',
	SIGN: 's-sign',
	SMART_PROCESS: 's-smart-process',
	SMILE: 's-smile',
	SOUND_OFF: 's-sound-off',
	SOUND_ON: 's-sound-on',
	STAGE: 's-stage',
	STOCK: 's-stock',
	STOP_HAND: 's-stop-hand',
	STORAGE: 's-storage',
	STRESS: 's-stress',
	SUBSCRIPTION: 's-subscription',
	TASK_LIST: 's-task-list',
	TASK: 's-task',
	TRASHCAN: 's-trashcan',
	VERIFICATION: 's-verification',
	WALLET: 's-wallet',
	WINDOW_FLAG: 's-window-flag',
	CROWN_1: 's-crown-1',
	_2GIS: 's-2gis',
	A_LETTER: 's-a-letter',
	A_LETTER_SORT_DOWN: 's-a-letter-sort-down',
	A_LETTER_SORT_UP: 's-a-letter-sort-up',
	ACHIEVEMENT: 's-achievement',
	ACTION_REQUIRED: 's-action-required',
	ADD_CHAT: 's-add-chat',
	ADD_EVENT: 's-add-event',
	ADD_FUNNEL: 's-add-funnel',
	AI_INTERNET_SEARCH: 's-ai-internet-search',
	AI_PROCESS: 's-ai-process',
	AI_PROJECTS: 's-ai-projects',
	AI_REFLECTION: 's-ai-reflection',
	AI_ROBOT: 's-ai-robot',
	AI_STARS_QUESTION: 's-ai-stars-question',
	AI_TWO_STARS: 's-ai-two-stars',
	ALARM: 's-alarm',
	ALIGN_CENTER: 's-align-center',
	ALIGN_IMAGE_CENTER: 's-align-image-center',
	ALIGN_IMAGE_LEFT: 's-align-image-left',
	ALIGN_IMAGE_RIGHT: 's-align-image-right',
	ALIGN_JUSTIFY: 's-align-justify',
	ALIGN_LEFT: 's-align-left',
	ALIGN_RIGHT: 's-align-right',
	ARROW_DOWN: 's-arrow-down',
	ARROW_TO_THE_LEFT: 's-arrow-to-the-left',
	ARROW_TO_THE_RIGHT: 's-arrow-to-the-right',
	ARROW_TOP: 's-arrow-top',
	ATTACH_2: 's-attach-2',
	AUTO_CHECK_IN: 's-auto-check-in',
	AUTO_SELECTION: 's-auto-selection',
	BACK: 's-back',
	BACK_10: 's-back-10',
	BACK_15: 's-back-15',
	BALL_ONE: 's-ball-one',
	BAN: 's-ban',
	BANK_CARD: 's-bank-card',
	BATTERY_1_STICK: 's-battery-1-stick',
	BATTERY_2_STICKS: 's-battery-2-sticks',
	BATTERY_NO_CHARGE: 's-battery-no-charge',
	BEER: 's-beer',
	BITRIX_GPT: 's-bitrix-gpt',
	BLACK_LIST: 's-black-list',
	BLOCK_INSERTION: 's-block-insertion',
	BLUETOOTH: 's-bluetooth',
	BOLD: 's-bold',
	BOOK_OPEN: 's-book-open',
	BOOKMARK_4: 's-bookmark-4',
	BOTTOM_MENU: 's-bottom-menu',
	BOTTOM_TOP_COLLAPSE: 's-bottom-top-collapse',
	BOX_WITH_LID: 's-box-with-lid',
	BRANCH_NETWORK: 's-branch-network',
	BROOM: 's-broom',
	BULLETED_LIST: 's-bulleted-list',
	BUSINESS_PROCESS_PROGRESS: 's-business-process-progress',
	CAKE_CELEBRATING: 's-cake-celebrating',
	CALENDAR: 's-calendar',
	CALENDAR_SHARE: 's-calendar-share',
	CALENDAR_WITH_CHECKS: 's-calendar-with-checks',
	CARD: 's-card',
	CHANGE_FUNNEL: 's-change-funnel',
	CHANGE_ORDER_3: 's-change-order-3',
	CHANGE_PLACES: 's-change-places',
	CHAT_LIST: 's-chat-list',
	CHECK_DEFERRED: 's-check-deferred',
	CHECK_IN_CANCEL: 's-check-in-cancel',
	CHECK_IN_NEGATIVE: 's-check-in-negative',
	CHECK_LIST: 's-check-list',
	CHEVRON_DOWN: 's-chevron-down',
	CHEVRON_TO_THE_LEFT: 's-chevron-to-the-left',
	CHEVRON_TO_THE_RIGHT: 's-chevron-to-the-right',
	CHEVRON_UP: 's-chevron-up',
	CIRCLE_CHECK_FORWARD: 's-circle-check-forward',
	CIRCLE_CROSS: 's-circle-cross',
	CIRCLE_MINUS: 's-circle-minus',
	CIRCLE_MORE: 's-circle-more',
	CIRCLE_PLUS: 's-circle-plus',
	CLAW: 's-claw',
	CLOCK_BACK: 's-clock-back',
	CLOUD_DOWNLOAD: 's-cloud-download',
	CLOUD_SYNC_CROSS: 's-cloud-sync-cross',
	CLOUD_TIME: 's-cloud-time',
	CLOUD_WITH_CHECK: 's-cloud-with-check',
	COLLAB_ADD: 's-collab-add',
	COLLAPSE: 's-collapse',
	COLLECTION: 's-collection',
	COLUMNS_SIDEBAR_PENDING: 's-columns-sidebar-pending',
	COLUMNS_SIDEBAR_PENDING_LEFT: 's-columns-sidebar-pending-left',
	COMMANDS: 's-commands',
	COMPASS: 's-compass',
	CONDITION: 's-condition',
	CONNECTION: 's-connection',
	CONTACT: 's-contact',
	CONTACT_DETAILS: 's-contact-details',
	CONTRAST: 's-contrast',
	COOKIES: 's-cookies',
	COPY_LINK: 's-copy-link',
	CORE: 's-core',
	CREATE_FILE: 's-create-file',
	CRM_FIELD_EXCEPT: 's-crm-field-except',
	CRM_FIELD_LINKED: 's-crm-field-linked',
	CRM_FIELD_SIMPLE: 's-crm-field-simple',
	CRM_FORM: 's-crm-form',
	CRM_ONLINE_STORE: 's-crm-online-store',
	CRM_OPTIONAL_ACCEPTED: 's-crm-optional-accepted',
	CRM_OPTIONAL_NOT_ACCEPTED: 's-crm-optional-not-accepted',
	CRM_PAYMENT_AND_DELIVERY: 's-crm-payment-and-delivery',
	CRM_REQUIRED_CONSENT: 's-crm-required-consent',
	CROSS: 's-cross',
	CROSSED_EYE: 's-crossed-eye',
	CROWN_FORWARD: 's-crown-forward',
	CUP_WINNER: 's-cup-winner',
	CURSORS_STRIKE: 's-cursors-strike',
	DATA_READING: 's-data-reading',
	DAY_OFF: 's-day-off',
	DELETE_EVENT: 's-delete-event',
	DEMONSTRATION_ON: 's-demonstration-on',
	DIAL_10: 's-dial-10',
	DIAL_20: 's-dial-20',
	DIGITS_123: 's-digits-123',
	DIGITS_24: 's-digits-24',
	DISCOUNT: 's-discount',
	DISIKE: 's-disike',
	DISTRIBUTION: 's-distribution',
	DO_NOT_USE_CAPTCHA: 's-do-not-use-captcha',
	DOTS: 's-dots',
	DOUBLE_CHECK: 's-double-check',
	DOWNLOAD: 's-download',
	DRAG: 's-drag',
	EARTH_WITH_CHECK: 's-earth-with-check',
	EARTH_WITH_CLOCK: 's-earth-with-clock',
	EARTH_WITH_CROSS: 's-earth-with-cross',
	EARTH_WITH_STOP: 's-earth-with-stop',
	EARTH_WITH_TREE: 's-earth-with-tree',
	EDIT: 's-edit',
	EMPTY_BATTERY: 's-empty-battery',
	EMPTY_MESSAGE: 's-empty-message',
	EXCEL: 's-excel',
	EXCLAMATION: 's-exclamation',
	EXCLAMATION_CIRCLE: 's-exclamation-circle',
	EXPAND: 's-expand',
	EXPERT_MODE: 's-expert-mode',
	EXPORT: 's-export',
	FACE_IDENT: 's-face-ident',
	FEEDBACK: 's-feedback',
	FEEDBACK_FORM: 's-feedback-form',
	FILE_WITH_CALENDAR: 's-file-with-calendar',
	FILE_WITH_CHECK: 's-file-with-check',
	FILE_WITH_CHECK_2: 's-file-with-check-2',
	FILE_WITH_CROWN: 's-file-with-crown',
	FILE_WITH_PERSON: 's-file-with-person',
	FILL_OUT_AGAIN: 's-fill-out-again',
	FILTER: 's-filter',
	FILTER_2: 's-filter-2',
	FILTER_2_LINES: 's-filter-2-lines',
	FILTER_FUNNEL: 's-filter-funnel',
	FIND_FILTERS: 's-find-filters',
	FINGERPRINT: 's-fingerprint',
	FLAG: 's-flag',
	FLAG_WITH_CROSS: 's-flag-with-cross',
	FLOWER: 's-flower',
	FOLDER_24: 's-folder-24',
	FOLDER_PLUS: 's-folder-plus',
	FOLDERS: 's-folders',
	FORM: 's-form',
	FORWARD: 's-forward',
	FORWARD_10: 's-forward-10',
	FORWARD_16: 's-forward-16',
	FRAME_CREATE: 's-frame-create',
	FREELANCE: 's-freelance',
	FUNCTION: 's-function',
	GALAXY: 's-galaxy',
	GALAXY_SERVER: 's-galaxy-server',
	GLASSES: 's-glasses',
	GLOBE_EXTRANET: 's-globe-extranet',
	GO_TO: 's-go-to',
	GOOGLE_MAPS: 's-google-maps',
	GRAPHS_SETTINGS: 's-graphs-settings',
	HAMBURGER_MENU: 's-hamburger-menu',
	HEADLINES: 's-headlines',
	HEADLINES_H1: 's-headlines-h1',
	HEADLINES_H2: 's-headlines-h2',
	HEADLINES_H3: 's-headlines-h3',
	HEADLINES_H4: 's-headlines-h4',
	HEADLINES_H5: 's-headlines-h5',
	HEADSET: 's-headset',
	HIDE_3: 's-hide-3',
	HIDE_4: 's-hide-4',
	HOME_STAR: 's-home-star',
	HOURGLASS: 's-hourglass',
	IDEA_LAMP: 's-idea-lamp',
	IMAGE: 's-image',
	IMAGE_PLUS: 's-image-plus',
	IMPORT: 's-import',
	INFO_CIRCLE: 's-info-circle',
	INTERVAL: 's-interval',
	INVENTORY_MANAGEMENT: 's-inventory-management',
	INVOICE: 's-invoice',
	IP_ADDRESS: 's-ip-address',
	IP_ADDRESS_CROSSED: 's-ip-address-crossed',
	ITALIC: 's-italic',
	KEYBOARD: 's-keyboard',
	LAYERS: 's-layers',
	LEFT_RIGHT: 's-left-right',
	LEGAL_PROCESS: 's-legal-process',
	LIBRARY_BASE: 's-library-base',
	LIGHTNING_PLUS: 's-lightning-plus',
	LINK: 's-link',
	LINK_SETTINGS: 's-link-settings',
	LINK_UPDATE: 's-link-update',
	LIST_TASKS_ADD: 's-list-tasks-add',
	LIST_VIEWER: 's-list-viewer',
	LOCATION_PLUS: 's-location-plus',
	LOCATION_TIME: 's-location-time',
	LOCK: 's-lock',
	LOCK_2: 's-lock-2',
	LOG_IN: 's-log-in',
	LOG_OUT: 's-log-out',
	LOGIN_HISTORY: 's-login-history',
	LOGO_ANDROID: 's-logo-android',
	LOGO_APPLE: 's-logo-apple',
	LOWER_LEFT_ARROW: 's-lower-left-arrow',
	LOWER_RIGHT_ARROW: 's-lower-right-arrow',
	MAP: 's-map',
	MARTINI_GLASS: 's-martini-glass',
	MAXIMIZE: 's-maximize',
	MAXIMIZE_2: 's-maximize-2',
	MCP: 's-mcp',
	MCP_LETTERS: 's-mcp-letters',
	MENTION: 's-mention',
	MERGE: 's-merge',
	MESSENGER: 's-messenger',
	MESSENGER_META: 's-messenger-meta',
	MICROPHONE_AI: 's-microphone-ai',
	MICROPHONE_SOUNDS_AI: 's-microphone-sounds-ai',
	MINIMIZE: 's-minimize',
	MINIMIZE_2: 's-minimize-2',
	MINUS: 's-minus',
	MOBILE: 's-mobile',
	MOBILE_FILL: 's-mobile-fill',
	MONEY_PRIZE: 's-money-prize',
	MORE: 's-more',
	MORE_VERTICAL: 's-more-vertical',
	MOVE_TO_CHECKLIST: 's-move-to-checklist',
	MULTI_PAGE_FORM: 's-multi-page-form',
	MULTICHOICE_OFF: 's-multichoice-off',
	MULTICHOICE_ON: 's-multichoice-on',
	MUSIC: 's-music',
	NEXT: 's-next',
	NO_COMPASS: 's-no-compass',
	NO_WIFI: 's-no-wifi',
	NON_FAVORITE: 's-non-favorite',
	NOTIFICATION_OFF: 's-notification-off',
	NOTIFICATION_SETTINGS: 's-notification-settings',
	NOTIFICATION_WITH_CROSS: 's-notification-with-cross',
	NUMBERED_LIST: 's-numbered-list',
	ONLINE_BANK: 's-online-bank',
	ONLINE_EVENTS: 's-online-events',
	OPEN_SEQUENCE: 's-open-sequence',
	OUTLINE_ICON_BOLD_AI_PROJECTS_2: 's-outline-icon-bold-ai-projects-2',
	PALETTE: 's-palette',
	PARTNER_NFC: 's-partner-nfc',
	PARTS_RECORD: 's-parts-record',
	PARTS_RECORD_PLAY: 's-parts-record-play',
	PARTS_RECORD_STOP: 's-parts-record-stop',
	PATH: 's-path',
	PAYMENT: 's-payment',
	PERSON_DETECT: 's-person-detect',
	PHONE_DOWN: 's-phone-down',
	PING: 's-ping',
	PLANNING: 's-planning',
	PLANNING_2: 's-planning-2',
	PLUG_LEFT: 's-plug-left',
	PLUG_RIGHT: 's-plug-right',
	POINT_LEFT: 's-point-left',
	POINT_RIGHT: 's-point-right',
	POWER: 's-power',
	PREVIOUS: 's-previous',
	PROCESS: 's-process',
	PROCESS_STOP: 's-process-stop',
	PRODUCTS_PAYMENT: 's-products-payment',
	PRODUCTS_SHIRT: 's-products-shirt',
	PROMPT_VAR: 's-prompt-var',
	PULSE: 's-pulse',
	QUANTITY: 's-quantity',
	QUESTION: 's-question',
	QUESTION_L: 's-question-l',
	QUICK_CRM_FILL: 's-quick-crm-fill',
	QUOTE: 's-quote',
	RECEIPT_NOTE: 's-receipt-note',
	RECENT_ITEMS: 's-recent-items',
	RECORD_ON: 's-record-on',
	REDIRECT: 's-redirect',
	REDO: 's-redo',
	REGISTRATION_ON_SITE: 's-registration-on-site',
	RELATED_TASKS: 's-related-tasks',
	REPEAT_CYCLE: 's-repeat-cycle',
	REPEAT_SALES: 's-repeat-sales',
	REPLY: 's-reply',
	REPLY_TO_ALL: 's-reply-to-all',
	RESUME: 's-resume',
	REVEAL_3: 's-reveal-3',
	REVEAL_4: 's-reveal-4',
	SALE_TAG: 's-sale-tag',
	SAVE_TEMPLATE: 's-save-template',
	SAVE_TEMPLATE_PLUS: 's-save-template-plus',
	SCRUM: 's-scrum',
	SEARCH: 's-search',
	SENDED: 's-sended',
	SERVICES: 's-services',
	SHARE: 's-share',
	SHARE_TASK: 's-share-task',
	SHIELD_ATTENTION: 's-shield-attention',
	SHOP_ORDER: 's-shop-order',
	SHUFFLE: 's-shuffle',
	SICK: 's-sick',
	SIGMA_SUMM: 's-sigma-summ',
	SIGN_DEFAULT: 's-sign-default',
	SIGNAL: 's-signal',
	SIGNAL_1: 's-signal-1',
	SIGNAL_2: 's-signal-2',
	SIZE_W_L: 's-size-w-l',
	SLASH: 's-slash',
	SMS: 's-sms',
	SORT_ACTIVITY: 's-sort-activity',
	SORT_CALENDAR: 's-sort-calendar',
	SPEAKER: 's-speaker',
	SPEAKER_ADD: 's-speaker-add',
	SPEED_0_5: 's-speed-0-5',
	SPEED_0_7: 's-speed-0-7',
	SPEED_1: 's-speed-1',
	SPEED_1_2: 's-speed-1-2',
	SPEED_1_5: 's-speed-1-5',
	SPEED_1_7: 's-speed-1-7',
	SPEED_2: 's-speed-2',
	SPEED_METER: 's-speed-meter',
	SPOILER: 's-spoiler',
	SSO: 's-sso',
	STAGE_MINUS: 's-stage-minus',
	STAGE_PLUS: 's-stage-plus',
	STAGES: 's-stages',
	START_EDUCATION: 's-start-education',
	STATISTICS_ARROW: 's-statistics-arrow',
	STICKER: 's-sticker',
	STOP: 's-stop',
	STRESS_NO: 's-stress-no',
	STRIKETHROUGH: 's-strikethrough',
	STRUCTURE_HORIZONTAL: 's-structure-horizontal',
	STRUCTURE_VERTICAL: 's-structure-vertical',
	SUBSCRIPT: 's-subscript',
	SUBTASK: 's-subtask',
	SUITCASE: 's-suitcase',
	SUN: 's-sun',
	SUPERSCRIPT: 's-superscript',
	SWITCH_CAMERA: 's-switch-camera',
	TABLET: 's-tablet',
	TAG: 's-tag',
	TELEPHONY: 's-telephony',
	TEMPLATE_TASK: 's-template-task',
	TEXT: 's-text',
	TEXT_FORMAT_BOTTOM: 's-text-format-bottom',
	TEXT_FORMAT_CANCEL: 's-text-format-cancel',
	TEXT_FORMAT_RESET: 's-text-format-reset',
	TEXT_FORMAT_TOP: 's-text-format-top',
	TEXT_FORMAT_TOP_LEFT: 's-text-format-top-left',
	TEXT_FORMAT_TOP_RIGHT: 's-text-format-top-right',
	THEME: 's-theme',
	THREAD: 's-thread',
	THREAD_SINGLE: 's-thread-single',
	THREADS: 's-threads',
	THREE_SQUARES: 's-three-squares',
	TIMELINE: 's-timeline',
	TIMER: 's-timer',
	TIMER_DOT: 's-timer-dot',
	TOP_BOTTOM_EXPAND: 's-top-bottom-expand',
	TOPIC: 's-topic',
	TRANSCRIPTION: 's-transcription',
	TRANSLATION: 's-translation',
	TREND_DOWN: 's-trend-down',
	TREND_UP: 's-trend-up',
	UNDERLINE: 's-underline',
	UNDO: 's-undo',
	UNIVERSAL_ACCESS: 's-universal-access',
	UNLINK: 's-unlink',
	UNLOCK: 's-unlock',
	UPLOAD: 's-upload',
	UPLOAD_DOCUMENT: 's-upload-document',
	UPLOAD_FILE: 's-upload-file',
	VACATION: 's-vacation',
	VIBE_PLUS: 's-vibe-plus',
	VIBE_PLUS_2: 's-vibe-plus-2',
	VIBECODE: 's-vibecode',
	VIDEO_RECORD: 's-video-record',
	VIDEO_RECORD_2: 's-video-record-2',
	VIDEO_RECORD_3: 's-video-record-3',
	VIDEO_RECORD_4: 's-video-record-4',
	VIDEO_RECORD_5: 's-video-record-5',
	VIRTUAL_SERVER: 's-virtual-server',
	VIRTUAL_STORAGE: 's-virtual-storage',
	VK_LEAD_FORM: 's-vk-lead-form',
	WEBHOOK: 's-webhook',
	WHATSAPP: 's-whatsapp',
	WIFI: 's-wifi',
	WINDOW_RING: 's-window-ring',
	YANDEX_MAPS: 's-yandex-maps',
	ZOOM_IN: 's-zoom-in',
	ZOOM_OUT: 's-zoom-out',
} as const);
